
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.5 5c3.433 0 5.645 2.066 6.5 2.938C16.855 7.067 19.067 5 22.5 5c4.138 0 7.5 3.404 7.5 7.5 0 2.857-2.469 5.031-2.469 5.031L16 29.094l-.719-.719L4.468 17.531s-.619-.573-1.219-1.469-1.25-2.134-1.25-3.563c0-4.096 3.362-7.5 7.5-7.5zm0 2C6.458 7 4 9.496 4 12.5c0 .772.423 1.716.906 2.438s.969 1.188.969 1.188L16 26.251l10.125-10.125S28 14.046 28 12.501c0-3.004-2.458-5.5-5.5-5.5-2.986 0-5.75 2.906-5.75 2.906l-.75.844-.75-.844S12.486 7.001 9.5 7.001z"}})])
          )
        }
      }
    